import requestMethods from '@/helpers/request/requestMethods';
import { userRecommendationsApiConfig, videoRecommendationsApiConfig } from '@/constants/ApiUrls';

async function getUserRecommendations({ links, params }) {
    return requestMethods
        .get({
            routeConfig: {
                ...userRecommendationsApiConfig,
                url: links?.next || userRecommendationsApiConfig.url
            },
            config: {
                params,
                handleLocal: ['Network Error', 404]
            }
        })
        .then((resp) => resp.data);
}

async function getVideoRecommendations({ links, params }) {
    return requestMethods
        .get({
            routeConfig: {
                ...videoRecommendationsApiConfig,
                url: links?.next || videoRecommendationsApiConfig.url
            },
            config: {
                params,
                handleLocal: ['Network Error', 404]
            }
        })
        .then((resp) => resp.data);
}

export { getUserRecommendations, getVideoRecommendations };
